export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    id: "faq-1",
    question: "星辰影视的安装包从哪里获取？",
    answer:
      "本页即为官方下载入口，页面内「手机版安装」与「TV 版安装」区域分别提供对应平台的安装包获取说明。请勿从论坛附件、群文件或来源不明的网盘链接下载，以免安装包被篡改。",
  },
  {
    id: "faq-2",
    question: "安装时提示「未知来源」无法继续怎么办？",
    answer:
      "这是系统对非应用商店安装的安全限制。Android 设备可进入「设置 → 安全」或「设置 → 应用管理」，为当前使用的浏览器开启「允许安装未知应用」，随后重新点击安装包即可。安装完成后可再关闭该权限。",
  },
  {
    id: "faq-3",
    question: "星辰影视支持哪些设备？",
    answer:
      "客户端覆盖 Android 手机与平板、iPhone 与 iPad、HarmonyOS 设备、Android TV 智能电视、智能电视盒子、智能投影仪，并额外提供 Windows 与 Mac 的网页版。具体最低系统版本可在「设备适配」区域按类别筛选查看。",
  },
  {
    id: "faq-4",
    question: "客户端会自动更新吗？",
    answer:
      "出于安装安全考虑，客户端采用手动更新方式。可在「设置 → 关于」中检测新版本，或回到本页下载最新安装包覆盖安装。覆盖安装不会清除已有的收藏与观看记录。",
  },
  {
    id: "faq-5",
    question: "iOS 版提示「未受信任的开发者」如何处理？",
    answer:
      "前往「设置 → 通用 → VPN 与设备管理」，在「企业级 App」或描述文件列表中找到对应的开发者条目，点击「信任」，然后返回桌面重新打开客户端即可。若列表中找不到，请确认描述文件已完整下载。",
  },
  {
    id: "faq-6",
    question: "TV 版安装后找不到图标怎么办？",
    answer:
      "大部分电视会把第三方应用归入「应用」或「我的应用」列表中，也可能在「+」添加应用的入口内。若仍未显示，请检查安装时是否误装了手机版安装包，TV 端必须使用 TV 版 APK。",
  },
  {
    id: "faq-7",
    question: "播放卡顿或频繁缓冲如何解决？",
    answer:
      "首先在播放页右下角将清晰度调低一档，例如从「超清」切换到「高清」；其次确认当前网络是否稳定，可尝试切换 Wi-Fi 或重启路由器；若使用投屏，请保证手机与电视处于同一局域网。",
  },
  {
    id: "faq-8",
    question: "使用星辰影视客户端需要付费吗？",
    answer:
      "客户端本身的下载与安装均不收费。页面中出现的版本号、安装包体积等信息仅用于帮助用户核对下载内容，具体内容与服务的可用范围以客户端内实际展示为准。",
  },
];